/**
 * Tabs Component - Component Definition
 * ========================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { TabsController } from './controller';
import { TABS_TEMPLATE } from './template';
import { BASE_CLASSES, TabsOption } from './constants';

export interface ITabsComponentBindings {
  options?: TabsOption[];
  onChange?: (args: { value: string }) => void;
}

export const tabsComponentDefinition: IComponentOptions = {
  template: TABS_TEMPLATE,
  controller: TabsController,
  require: { ngModelCtrl: '?ngModel' },
  bindings: {
    options: '<',
    onChange: '&?'
  }
};

export const MODULE_NAME = 'ec.tabs';

const tabsModule: IModule = angular.module(MODULE_NAME, []).component('ecTabs', tabsComponentDefinition);

export { TabsController, TABS_TEMPLATE, BASE_CLASSES };

export type { TabsOption } from './constants';

export default tabsModule;
